/*
 * cart-guard.js — defense-in-depth: keep $0 / not-for-sale products out of the bag.
 *
 * The product-card / PDP / sticky buttons are already disabled for these products,
 * but this guard also catches any edge path (bundles, direct /cart/add, JS bypass):
 * after any cart change (and on load), it removes line items whose price is 0 or
 * whose vendor is "Not For Sale", then refreshes the cart UI via the theme's
 * cartUpdate pubsub. Removal is server-side (/cart/change.js), so even if the UI
 * refresh is missed the item is gone on the next load. Everything is wrapped in
 * try/catch + a busy flag + a source guard so it can never loop or break the cart.
 */
(function () {
  if (window.__cartGuardInit) return;
  window.__cartGuardInit = true;

  var busy = false;

  function isBad(item) {
    if (!item) return false;
    if (item.price === 0 || item.final_price === 0) return true;
    var v = (item.vendor || '').toLowerCase().replace(/[\s\-_]/g, '');
    return v === 'notforsale';
  }

  function cartUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';
  }

  function refresh() {
    // Re-fetch the cart and hand it to the theme's cart subscribers so the drawer,
    // count bubble and cart page re-render. Payload shape mirrors cart.js ({ cart }).
    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try {
          if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-guard', cart: cart });
          }
        } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      })
      .catch(function () {});
  }

  function guard() {
    if (busy) return;
    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(isBad);
        if (!bad.length) return;
        busy = true;
        var chain = Promise.resolve();
        bad.forEach(function (it) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 0 }),
            });
          });
        });
        return chain.then(function () { busy = false; refresh(); });
      })
      .catch(function () { busy = false; });
  }

  // Initial sweep + back/forward cache restores.
  if (document.readyState !== 'loading') guard();
  else document.addEventListener('DOMContentLoaded', guard);
  window.addEventListener('pageshow', guard);

  // Re-check after every cart mutation the theme announces (ignore our own refresh).
  function subscribeWhenReady(tries) {
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.subscribe) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (evt && evt.source === 'cart-guard') return;
          guard();
        });
        return;
      }
    } catch (e) {}
    if (tries > 0) setTimeout(function () { subscribeWhenReady(tries - 1); }, 300);
  }
  subscribeWhenReady(20);
})();
